export default __webpack_public_path__ + "static/media/close_hover.84356ad0.svg";